// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"58":"cbccc852","70":"08e20d2d","392":"456fb92a","856":"282b5c64","956":"9e8e3872"}[chunkId] + ".css";
};